import { query, mutation } from '@/services/graphql';
import * as operations from './operations';

export default {
  examData(variables = {}) {
    return query(operations.EXAMDATA, variables, true);
  },
  submitExamResult(variables = {}) {
    return mutation(operations.SUBMITEXAMRESULT, variables, true);
  },
};
